<template>
  <div class="fix-list px-3 pt-3 pb-2">
    <div class="fix-item" v-for="(item, index) in items" :key="index">
      <h3 class="title mb-3">{{ index + 1 }}. {{ item.order_item_name }}</h3>
      <div class="d-flex justify-content-between mb-3">
        <div>
          <div class="label">{{ $t("feature.homecare.fix_status") }}</div>
          <div
            class="value status homecare-status"
            :class="[item.order_item_status_code]"
          >
            {{ $t("feature.homecare.status." + item.order_item_status_code) }}
          </div>
        </div>
        <div v-if="item.new_job_order_id">
          <div class="label">{{ $t("feature.homecare.fix_note") }}</div>
          <div class="value">
            {{
              $t("feature.homecare.fix_new") + " " + item.new_job_order_id ||
                "-"
            }}
          </div>
        </div>
      </div>
      <div class="description mb-3">
        <div class="label">{{ $t("feature.homecare.description") }}</div>
        <div class="value">{{ item.joborder_item_note || "-" }}</div>
      </div>
      <div class="images">
        <sc-thumbnail
          v-for="(image, index) in item.order_item_images"
          :key="index"
          :imgSrc="image.image_url"
          imgClass="sc-image p-0 mr-2 mb-2"
          :openLink="true"
        ></sc-thumbnail>
      </div>
    </div>
  </div>
</template>

<script>
import Thumbnail from "@/components/helper/Thumbnail";

export default {
  props: {
    items: {
      type: Array
    }
  },
  components: {
    "sc-thumbnail": Thumbnail
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.fix-item {
  padding: 16px;
  background: #f9f9f9;
  border-radius: 15px;
  margin-bottom: 8px;
}
h3.title {
  font-size: 16px;
  font-weight: bold;
  margin: 0 0 6px 0;
}
.description {
  font-size: 16px;
  font-weight: 500;
  color: #4a4a4a;
}
.images {
  display: flex;
  flex-wrap: wrap;
  .sc-image {
    border-radius: 13.6px;
    position: relative;
    width: 100px;
    height: 100px;
    overflow: hidden;
  }
}
.label {
  font-size: 11px;
  font-weight: 500;
  color: #8c8786;
  margin-bottom: 8px;
}
.value {
  font-size: 16px;
  font-weight: 500;
}
.status {
  font-size: 16px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/homecare/FixList.vue